document.addEventListener('on:facet-filters:updated', e => {
  window.dispatchEvent(new Event("scroll"))
});

document.addEventListener("BSS:openQuickBuy", e => {
  setTimeout(() => {
    updateVariant();
    const variantId = +document.querySelector(`quick-add-drawer [action="/cart/add"] [name="id"]`)?.value;
    if(variantId) return;
          variant = BSS_B2B.storage.variantStorage.get(variantId);
      if (variant?.appliedCP){
              const cpPrices = {
                  price: variant.bssB2BPriceAfterCP,
                  comparePrice: variant.compare_at_price ?? variant.price,
                  originalPrice: variant.price,
              };
          const priceElements = document.querySelectorAll("quick-add-drawer .product-info__price>span")
              priceElements.forEach((priceElement) => {
                  BSS_B2B.cp?.utils?.product?.showPriceBase(priceElement, cpPrices);
              });
      }
    changeVariantQV();
  }, 1000)
});

function changeVariantQV(){
  document.querySelector("variant-picker").addEventListener("on:variant:change", e => {
      updateVariant();
      let { variant } = e.detail;
      variant = BSS_B2B.storage.variantStorage.get(variant.id);
      if (variant?.appliedCP){
              const cpPrices = {
                  price: variant.bssB2BPriceAfterCP,
                  comparePrice: variant.compare_at_price ?? variant.price,
                  originalPrice: variant.price,
              };
          const priceElements = document.querySelectorAll("quick-add-drawer .product-info__price>span")
              priceElements.forEach((priceElement) => {
                  BSS_B2B.cp?.utils?.product?.showPriceBase(priceElement, cpPrices);
              });
      }
  })
}
  function updateVariant(){
      const CP_KEY = 'cp';
    for (const [a,product] of BSS_B2B.storage.productStorage.store) {
      product.variants.forEach((variant, ind) => {
          const appliedRule = BSS_B2B.cp.utils.common.getCustomerAppliedRules().find(rule => BSS_B2B.cp.utils.common.checkProduct(rule, { ...product, currentVariant: variant }))
          if (appliedRule) {
              product.variants[ind].appliedCP = appliedRule;
              const { discount_type, discount_value } = appliedRule;
              const modifiedPrice = BSS_B2B.cp.utils.common.calculateDiscount(variant.price, discount_type, Number(discount_value));
              if (modifiedPrice !== variant.price) {
                  product.variants[ind].bssB2BPriceAfterCP = modifiedPrice;
                  product.variants[ind].bssB2bShowPriceKey = BSS_B2B.utils.getModuleKeyByPriority(variant.bssB2bShowPriceKey, CP_KEY);
                  product.bssB2bShowPriceKey = BSS_B2B.utils.getModuleKeyByPriority(product.bssB2bShowPriceKey, CP_KEY);
              } else {
                  delete variant.appliedCP;
                  delete variant.bssB2BPriceAfterCP;
                  if (variant.bssB2bShowPriceKey === CP_KEY) {
                      delete variant.bssB2bShowPriceKey;
                  }
                  if (product.bssB2bShowPriceKey === CP_KEY) {
                      delete product.bssB2bShowPriceKey;
                  }
              }
              BSS_B2B.storage.variantStorage.set(variant.id, variant);
              BSS_B2B.storage.productStorage.set(product.id, product);
          }
      })
  }
}